import API from '@/api/api.js'
import Moment from 'moment';

export default class AccountAPIList {
	constructor() {
		let api = new API();
		this.api = api;
	}

	getUserDetail(param, success, error) {
		this.api.get('/user/detail', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	getUserCreditsTxn(param, success, error) {
		this.api.get('/user/getCreditsTxn', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	editUserPassword(param, success, error) {
		this.api.post('/user/editPassword', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	editReceipt(param, success, error) {
		this.api.post('/user/editReceipt', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

}



// WEBPACK FOOTER //
// ./src/api/Account/apiList.js